import { Fragment } from 'react'
import { BannerBottom } from './BannerBottom'
import { BannerTop } from './BannerTop'
interface IAboutUsPageTabItemProps {
  activeTab?: string
}

const BannerTab = ({ activeTab }: IAboutUsPageTabItemProps) => {
  return (
    <Fragment>
      <div className="bg-white p-5 pt-[60px]">
        <div>
          <>
            <BannerTop activeTab={activeTab} />
            <BannerBottom activeTab={activeTab} />
          </>
        </div>
      </div>
    </Fragment>
  )
}

export default BannerTab
